import React from 'react';
import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/971544223506"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center gap-3 px-6 py-4 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={24} className="animate-pulse" />
      <span className="font-semibold hidden sm:block">Chat with Our Advisor</span>
      <span className="font-semibold sm:hidden">Chat Now</span>
    </a>
  );
};
